import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs';

if (!customElements.get('collections-slider')) {
  class CollectionsSlider extends HTMLElement {
    selectors = {
      swiper: '.swiper',
      navigation: {
        prevEl: '.collections-slider__prev',
        nextEl: '.collections-slider__next'
      }
    };
    settings = {
      slidesPerView: 'auto',
      spaceBetween: 16,
      navigation: {
        ...this.selectors.navigation
      }
    };
    slider = undefined;

    breakpoint = window.matchMedia('(min-width: 990px)');

    constructor() {
      super();
    }

    connectedCallback() {
      this.breakpoint.matches && this.init();
      this.breakpoint.addEventListener('change', () => this.breakpoint.matches ? this.init() : this.destroy());
    }

    init() {
      this.slider = new Swiper(this.querySelector(this.selectors.swiper), this.settings);
    }

    destroy() {
      this.slider?.destroy();
    }
  }
  customElements.define('collections-slider', CollectionsSlider);
}
